import { initialState } from "./state"

export default {
  updateCurrentStep: (state, payload) => (state.currentStep = payload),
  updateLoading: (state, payload) => (state.loading = payload),
  updateSteps: (state, payload) => (state.steps = payload),
  updateStepsNamesRoutes: (state, payload) =>
    (state.stepsNamesRoutes = payload),
  updateSegmentOptions: (state, payload) =>
    (state.segmentOptions = payload),
  updateInformation: (state, payload) =>
    (state.information = { ...state.information, ...payload }),
  updateOrderConfig: (state, payload) =>
    (state.orderConfig = { ...state.orderConfig, ...payload }),
  updateBiometryConfig: (state, payload) =>
    (state.biometryConfig = { ...state.biometryConfig, ...payload }),
  updateSecurityConfig: (state, payload) =>
    (state.securityConfig = { ...state.securityConfig, ...payload }),
  resetProvider: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  }
}
